export default "__VITE_ASSET__vYaq104l__"